type CaseOutcome = {
  readonly outcome: "approved" | "denied" | "closed" | "ire_auto_forwarded"
}


export const getOverallOutcome = (outcomes: readonly CaseOutcome[] | undefined): "approved" | "denied" | "closed" | null => {
  if (!outcomes?.length) {
    return null;
  } else {
    const outcomeSet = new Set(outcomes.map((co) => co.outcome));
    if (outcomeSet.size == 1) {
      const outcome = [...outcomeSet][0];
      return outcome == "ire_auto_forwarded" ? "closed" : outcome;
    } else if (outcomeSet.has("denied")) {
      return "denied";
    } else {
      // Unexpected
      return null;
    }
  }
};
